// extracted by mini-css-extract-plugin
module.exports = {"content":"Home_content__-VV4m","buttonSpace":"Home_buttonSpace__3npjK"};